import React from 'react';
import ClassNames from 'classnames';
import { oneOf, string } from 'prop-types';

import './ContentPlaceholder.scss';

const ContentPlaceholder = props => {
  const { className, shape } = props;

  const classNames = ClassNames(
    'content-placeholder',
    className,
    `content-placeholder--${shape}`
  );

  return <div className={classNames} />;
};

ContentPlaceholder.propTypes = {
  className: string,
  shape: oneOf(['circle', 'pill', 'square']).isRequired
};

ContentPlaceholder.defaultProps = {
  className: ''
};

export default ContentPlaceholder;
